/** Strips leading ATX heading markers (e.g. from markdown or from merged JSON titles). */
export function stripAtxHeading(line: string): string {
  return line.replace(/^(?:#{1,6}\s+)+/, '')
}
